<template>
  <div class="search-container">
    <!-- 高级搜索 -->
    <div class="advanced-search" v-show="appStore.device === 'desktop'">
      <slot name="searchBefore"></slot>
      <i class="el-icon-search"></i>
      <span class="search-text" @click="showAdvancedDialog">高级搜索</span>
    </div>
    <!-- 分割线 -->
    <el-divider
      direction="vertical"
      border-style="dashed"
      content-position="center"
      v-show="appStore.device === 'desktop'"
    />
    <!-- 单项搜索 -->
    <div class="search-params" v-if="outSearchCols.length > 0">
      <slot name="selectSearch">
        <OutSearch ref="outSearchRef" :columns="outSearchCols" />
      </slot>
      <el-button class="search-btn" type="primary" @click="searchClicked"
        >搜索</el-button
      >
      <el-button
        class="mr10"
        :class="{ ml5: appStore.device !== 'desktop' }"
        type="primary"
        plain
        @click="resetClicked"
        >重置</el-button
      >
    </div>
    <!-- 高级搜索提示框 -->
    <AdvSearchDia
      v-model="asdVisible"
      :tableColumns="tableColumns"
      :reset="searchReset"
      :initial-search-params="initialSearchParams"
      @onSearch="onAdvancedSearch"
    >
    </AdvSearchDia>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import OutSearch from "./OutSearch";
import AdvSearchDia from "./advSearchDia.vue";

import useSettingsStore from "@/store/modules/settings";

import useAppStore from "@/store/modules/app";

const appStore = useAppStore();

const settingsStore = useSettingsStore();

const props = defineProps({
  tableColumns: {
    required: true,
    type: Array,
  },
  // 初始搜索参数
  initialSearchParams: {
    required: false,
    type: Array,
    default: [],
  },
  searchAttrName: {
    // 可以搜索的属性
    type: Array,
    default: () => [],
  },
  showSelectSearch: {
    // 可以搜索的属性
    type: Boolean,
    default:false,
  },
});
const asdVisible = ref(false); // 高级搜索是否显示

const isAdvSearch = ref(false); // 是否是高级搜索

const outSearchRef = ref(null);

// 选中查询选项
const searchType = ref("");
const searchVal = ref("");
// 更新搜索的值
const updateVal = (index, type, val) => {
  searchType.value = type;
  searchVal.value = val;
  const searchData = {};
  searchData[type] = val;
  emits("onUpdateVal", searchData);
};

const showAdvancedDialog = () => {
  asdVisible.value = true;
};

const emits = defineEmits(["onCustomSearch", "onUpdateVal"]);

const advancedSearchParam = ref({});
const outSearchParam = ref({});

// 搜索按钮点击
const searchClicked = () => {
  if (searchVal.value === "") {
    outSearchParam.value = {};
  } else {
    if (props.itemSearch) {
      const searchParams = {};
      searchParams[`${searchType.value}`] = searchVal.value;
      outSearchParam.value = searchParams;
    } else {
      outSearchParam.value = { search: searchVal.value };
    }
  }
  isAdvSearch.value = false;
  emitsSearch();
};

const searchReset = ref(false);
// 重置
const resetClicked = () => {
  advancedSearchParam.value = {};
  outSearchParam.value = {};
  searchVal.value = "";
  searchReset.value = !searchReset.value;
  if(!props.showSelectSearch){
    outSearchRef.value.resetSearch();
  }
  emits("onCustomSearch", "reset");
};

// 高级搜索
const onAdvancedSearch = (searchItems, exectSearch = true) => {
  const searchData = {};
  searchItems.forEach((item) => {
    if (item[0] !== "" && item[1] !== "") {
      searchData[item[0]] = item[1];
    }
  });
  advancedSearchParam.value = searchData;
  if (exectSearch) {
    isAdvSearch.value = true;
    emitsSearch(); // 发送搜索信号
  }
};

// 发送 搜索
const emitsSearch = () => {
  emits("onCustomSearch");
};

const setSearchVal = (searchData, type, val) => {
  if (val instanceof Array) {
    const _type = type.split(",");
    for (let i = 0; i < _type.length; i++) {
      searchData[_type[i]] = val[i];
    }
  } else {
    searchData[type] = val;
  }
};

const theme = ref(settingsStore.theme);

// 表格外边搜索参数
const outSearchCols = ref([]);
const getOutSearchCols = () => {
  const searchCols = [];
  if (props.searchAttrName.length > 0 && props.tableColumns.length > 0) {
    let index = 0;
    props.tableColumns.forEach((item) => {
      const findProp = props.searchAttrName.find((prop) => prop === item.prop);
      if (findProp && item && index < 3) {
        searchCols.push(item);
      }
    });
  }
  if (searchCols.length === 0) {
    let flag = true;
    let index = 0;
    while (flag && index < props.tableColumns.length) {
      if (props.tableColumns[index].search !== false) {
        searchCols.push(props.tableColumns[index]);
        flag = false;
      }
      index++;
    }
  }
  outSearchCols.value = searchCols;
};

onMounted(() => {
  watch(
    () => settingsStore.theme,
    (newVal) => {
      theme.value = newVal;
    }
  );
  watch(
    () => props.tableColumns,
    (newVal) => {
      getOutSearchCols();
    },
    {
      immediate: true,
    }
  );
});

/**
 * 获取搜素参数
 */
const getSearchParams = () => {
  const searchData = {};
  if (isAdvSearch.value) {
    /**
     * 高级搜索，高级搜索的参数优先级最高
     */
    for (let [type, val] of Object.entries(
      outSearchRef.value?.getSearchParams()
        ? outSearchRef.value.getSearchParams()
        : {}
    )) {
      setSearchVal(searchData, type, val);
    }
    for (let [type, val] of Object.entries(advancedSearchParam.value)) {
      setSearchVal(searchData, type, val);
    }
  } else {
    /**
     * 普通搜索，普通搜索的参数优先级最低
     */
    for (let [type, val] of Object.entries(advancedSearchParam.value)) {
      setSearchVal(searchData, type, val);
    }
    for (let [type, val] of Object.entries(
      outSearchRef.value?.getSearchParams()
        ? outSearchRef.value.getSearchParams()
        : {}
    )) {
      setSearchVal(searchData, type, val);
    }
  }

  const whereSqlList = [];
  for (const key in searchData) {
    //搜索数据的值不能为空;
    if (
      searchData[key] !== "" &&
      searchData[key] !== 0 &&
      searchData[key] !== null &&
      searchData[key].value !== ""
    ) {
      whereSqlList.push(searchData[key]);
    }
  }
  if (whereSqlList.length > 0) {
    return { whereSql: JSON.stringify(whereSqlList) };
  } else {
    return {};
  }
};

defineExpose({
  getSearchParams,
  getSearchText: () => outSearchRef.value?.getSearchText(),
});
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;

  .advanced-search {
    margin-right: 30px;
    margin-left: 10px;
    line-height: 36px;
  }

  .search-text:hover {
    color: v-bind(theme);
    cursor: pointer;
  }

  :deep(.el-divider) {
    height: 32px;
    margin-right: 20px;

    //line-height: 32px;
  }

  .search-params {
    display: flex;

    .el-select--small {
      width: 150px;
    }

    .search-val {
      margin-left: 2px;
      width: 200px;
      position: relative;
      //top: -1px;
    }

    .search-btn {
      margin-left: 10px;
    }
  }
}
</style>
